import { Box, Grid } from "@mui/material";

interface C02Props {
    CO2: number
}

export default function EmissionsIndicator({CO2} : C02Props) {

    return (
        <Box
        display='flex'
        alignItems='center'
        height={200}
        sx={{
            fontSize: '3rem',
            fontWeight: 'bolder',
            color: '#77c768',
            borderRadius: '15px',
            border: '3px solid #77c768'
        }}
        >
            <Grid container direction='column' alignItems='center' justifyContent='center' textAlign='center'>
                {Math.round(CO2/1000)}kg
                <p style={{ fontSize: '1rem', fontWeight: 'bolder' }}>CO2 Emissions Reduced</p>
            </Grid>
        </Box>
    )
}